module.exports = __webpack_public_path__ + "static/media/tiktok.f6abf4f1.svg";